import cx from 'classnames'
import PropTypes from 'prop-types'

import {ATOM_ICON_DESIGNS} from '@s-ui/react-atom-icon'
import IconHeartSolid from '@adv-mt/mt-svg-icons/lib/HeartSolid'

const BASE_CLASS = 'mt-actionAdFavorite-buttonIcon'

const ActionAdFavoriteButtonIcon = ({isMarked}) => {
  const classNames = cx(BASE_CLASS, {
    [`${BASE_CLASS}--marked`]: isMarked
  })

  return (
    <div className={classNames}>
      <IconHeartSolid
        aria-hidden
        color="currentColor"
        design={isMarked ? ATOM_ICON_DESIGNS.FILLED : ATOM_ICON_DESIGNS.OUTLINE}
        role="presentation"
        size="medium"
      />
    </div>
  )
}

ActionAdFavoriteButtonIcon.propTypes = {
  isMarked: PropTypes.bool
}

export default ActionAdFavoriteButtonIcon
